import { SuperAdminService } from "services/superAdminService";

class AppVersionsSAService extends SuperAdminService<any> {
  constructor() {
    super("app-versions");
  }
}
export default new AppVersionsSAService();
